import { observer } from "mobx-react-lite";

import { SvgGenerator, type Path } from "@/components/expression/svgUtils/SvgGenerator";

import type { DecoratorNodeModel } from "@/models/nodes/DecoratorNodeModel";

const HAT_PATH: Path = ["stroke", "M 1 {100h-1} L {50w} 1 L {100w-1} {100h-1}"];

type Props = {
  node: DecoratorNodeModel;
};

export const WideHat = observer(function WideHat({ node: _node }: Props) {
  return (
    <div className="absolute -left-[1px] -right-[1px] text-document-text h-2.5 top-[2px] -translate-y-full">
      <SvgGenerator paths={[HAT_PATH]} />
    </div>
  );
});
